export class User {
    id: string;
    name: string;
    password: string;
    email: string;
    reset_code: string;
    auth_code: string;
    lang: string;
    branch_id: string;
  department_id: string;
    role_id:string;
    status: string;
    picture:any;
    tel:string;
    mobile:string;
    newPassword:string;
    row_id: string;
    creation_user: string;
    branch_users:string;
  department_users:string;
    creation_ip: string;
    created_at: string;
    updated_at: string;
    permissions:string;
  department_branches:string;

    change_password_first_login:string;
    two_factor_authentication:string;
    showDeletedOnly: boolean;

  constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/model/user.ts